import { OTP_LENGTH } from '@config';

export function isValidOtp(otp: string): boolean {
    return otp.length === OTP_LENGTH;
}
